import { render } from "./NewChirpDialog.vue?vue&type=template&id=5bdaa654&ts=true"
import script from "./NewChirpDialog.vue?vue&type=script&lang=ts"
export * from "./NewChirpDialog.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__